import { MathUtils, Vector2 } from 'three';
const PLANOGRAM_OFFSET_RATIO = 0.25;
const FONT_UNIT_RATIO = 0.0025;
export const HEIGHT = 2500;
export const WIDTH = 10000;
// TODO: merge the two planogram configs
const planogramConfig = {
    HEIGHT,
    WIDTH,
    EQUATOR_RADIUS: WIDTH / (Math.PI * 2.0),
    SHELL_RADIUS: (WIDTH / (Math.PI * 2.0)) * 3.0,
    ALPHA: MathUtils.degToRad(10.0),
    VIEWABLE_LIMIT_TOP: 3350,
    VIEWABLE_LIMIT_BOTTOM: 1650,
    PAGES_WIDE: 256,
    PAGES_HIGH: 64,
    MAX_OBJECT_SIZE: new Vector2(WIDTH / 2, HEIGHT),
};
export default planogramConfig;
export const PLANOGRAM_CONFIG = {
    height: HEIGHT,
    width: WIDTH,
    maxZoom: 50,
    maxPreviewZoom: 9.99,
    fov: 75,
    maxTexture: 4096,
    startingPoint: 180,
    horizonLine: 0.27,
    virtualSphereY: HEIGHT * 2 * PLANOGRAM_OFFSET_RATIO,
    headerSize: 106,
    footerSize: 32,
    defaultLayersWidth: 260,
    builderHeaderSize: 70,
    builderLeftPanelSize: 316,
    fontUnitSize: FONT_UNIT_RATIO * HEIGHT,
    letterSpacingUnitSizes: (FONT_UNIT_RATIO * HEIGHT) / 1000,
    resizeHandleSize: 8,
    resizeHandlePadding: 4,
};
